<script>
const axios = require('axios').default;

export default {
	name: 'newsletter',

	data() {
		return {
			error: '',
			success: '',
			email: '',
			name: '',
		};
	},

	props: {
        list_id: String,
	},

	methods: {
		submit() {
			let _self = this;

			_self.success = '';
			_self.error   = '';

			let url = window.acm.ajax_url

			let form_data = new FormData;
			form_data.append('action', 'bute_signup');
			form_data.append('email', _self.email);
			form_data.append('name',  _self.name);
			form_data.append('list_id',  _self.list_id);

			axios
				.post(url, form_data)
				.then(function(response) {
					_self.success = response.data.success;
					_self.error   = response.data.error;

					if (_self.success) {
						_self.email = '';
						_self.name  = '';
					}
				}).catch(function(e) {
					_self.error = e.message;
				});
		}
	},

	mounted() {

	},
};

</script>